<template>
  <el-button @click="goToPage">新tab打開頁面</el-button>
</template>
<script>
export default {
  methods: {
    goToPage() {
      window.parent.postMessage({ url: "/mgr", name: "111" }, "*");

    //   window.addEventListener(
    //     "message",
    //     (e) => {
    //       if (e && e.data && e.data.url && e.data.url) {
    //         var dataUrl = e.data.url;
    //         var menuName = e.data.name;
    //         var dataIndex=new Date().getTime()
    //         var str =
    //           '<a href="javascript:;" class="active J_menuTab" data-id="' +
    //           dataUrl +
    //           '">' +
    //           menuName +
    //           ' <i class="fa fa-times-circle"></i></a>';
    //         $(".J_menuTab").removeClass("active");

    //         // 添加选项卡对应的iframe
    //         var str1 =
    //           '<iframe class="J_iframe" name="iframe' +
    //           dataIndex +
    //           '" width="100%" height="100%" src="' +
    //           dataUrl +
    //           '" frameborder="0" data-id="' +
    //           dataUrl +
    //           '" seamless></iframe>';
    //         $(".J_mainContent")
    //           .find("iframe.J_iframe")
    //           .hide()
    //           .parents(".J_mainContent")
    //           .append(str1);

    //         //显示loading提示
    //         var loading = layer.load();

    //         $(".J_mainContent iframe:visible").load(function () {
    //           //iframe加载完成后隐藏loading提示
    //           layer.close(loading);
    //         });
    //         // 添加选项卡
    //         $(".J_menuTabs .page-tabs-content").append(str);
    //         scrollToTab($(".J_menuTab.active"));
    //       }
    //     },
    //     false
    //   );
    },
  },
  mounted(){
    // console.log(top)
    // top.location.href="https://www.baidu.com/"
  }
};
</script>